export class QueueBatchProcessor {
    #options;
    #queue = [];
    #sending = false;
    constructor(options) {
        this.#options = options;
    }
    init() {
        if (this.#options.intervalDelaySecs) {
            setInterval(this.#sendBatch, this.#options.intervalDelaySecs * 1000);
        }
    }
    #sendBatch = async () => {
        if (!this.#queue.length || this.#sending) {
            return;
        }
        this.#sending = true;
        const batch = this.#queue.slice(0, this.#options.maxBatch || this.#queue.length);
        try {
            await this.#options.callback(batch);
            this.#queue = this.#queue.slice(batch.length);
        }
        catch (e) {
        }
        this.#sending = false;
    };
    addToQueue(item) {
        this.#queue.push(item);
        if (this.#queue.length >= this.#options.maxBatch) {
            this.#sendBatch();
        }
    }
}
